export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/ob-step-6.png?7ed9b7366256e0b7826ab4e1efc5eb06";